import type {
  TValidIrrigationSchedulerZoneEmitter,
  TValidIrrigationSchedulerZoneEmitterId,
} from 'stores/fieldAssetStore/helperTypes'
import { makeNameEmitterTypeLabel } from 'utils/makeNameEmitterTypeLabel'
import { sortByKey } from 'utils/sortByKey'

export const getSelectOptionsFromEmitters = (
  emitters: Record<TValidIrrigationSchedulerZoneEmitterId, TValidIrrigationSchedulerZoneEmitter>,
) => {
  return Object.values(emitters)
    .map((e) => ({ value: e.irrigationZoneEmitterId, label: makeNameEmitterTypeLabel(e) }))
    .sort(sortByKey('label'))
}
